import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useClassName, useWindowSize } from 'common/hooks';
import { ControlledInputContainer } from 'public/components/ControlledInputContainer';
import { SVGIcon } from 'common/components';
import { BottomSheet } from 'public/components/BottomSheet';
import { Dropdown } from 'public/components/Dropdown';
import { getOptionLabel, toOption } from 'common/helpers';

import './select.less';

const Select = ({
  items,
  selectedItem,
  setSelectedItem,
  error,
  onBlur,
  placeholder,
  readOnly,
}) => {
  const [open, setOpen] = useState(false);
  const classNames = useClassName('Select');
  const { isMobile } = useWindowSize();
  const options = (items || []).map(toOption);

  const content = (
    <div className={classNames('list')}>
      {options.map(({ value, label }) => (
        <div
          key={value}
          className={classNames('item')}
          onClick={() => {
            onBlur({ value });
            setSelectedItem(value);
            setOpen(false);
          }}>
          <span>{label}</span>
        </div>
      ))}
    </div>
  );

  return (
    <ControlledInputContainer
      input={
        <input
          value={selectedItem ? getOptionLabel(options, selectedItem) : ''}
          readOnly
          data-locked={readOnly || undefined}
          placeholder={placeholder}
        />
      }
      addonRight={
        <SVGIcon name="angle-down" className={classNames('addon-right')} />
      }
      onClick={() => !readOnly && setOpen(true)}
      hasFocus={open}
      error={error}
      trigger={
        isMobile ? (
          <BottomSheet
            onClose={() => {
              onBlur({});
              setOpen(false);
            }}
            title="Select"
            isOpen={open}
            content={content}
          />
        ) : (
          <Dropdown
            isOpen={open}
            onClose={() => {
              onBlur({});
              setOpen(false);
            }}
            content={content}
            useTriggerWidth
          />
        )
      }
    />
  );
};

Select.propTypes = {
  items: PropTypes.array,
  selectedItem: PropTypes.string,
  setSelectedItem: PropTypes.func,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default Select;
